module.exports = __webpack_public_path__ + "static/media/scheduler_text_carousel.11c383f3.xlsx";